import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/route-patterns'

const URL_APPROVALS_MANAGEMENT = `${URL_APP_ADMIN}/approvals-management`
export const URL_AML_SITE_SETUP_FORM_ACCESS_APPROVAL_REQUEST = `${URL_APPROVALS_MANAGEMENT}/site-setup-form-access-approval-request/:approvalRequestId`

export type SiteSetupFormAccessDashRouteSet =
  DashRouteType<'app-admin-approvals-management-library-site-setup-form-access-approval-request'>

export const siteSetupFormAccessRoutes: {
  [Key in SiteSetupFormAccessDashRouteSet['identifier']]: string
} = {
  'app-admin-approvals-management-library-site-setup-form-access-approval-request':
    URL_AML_SITE_SETUP_FORM_ACCESS_APPROVAL_REQUEST,
}

export type SiteSetupFormAccessDomainRouteName = keyof typeof siteSetupFormAccessRoutes
